import { DotLottiePlayer } from "@dotlottie/react-player";
import "@dotlottie/react-player/dist/index.css";
import * as Dialog from "@radix-ui/react-dialog";
import React from "react";
import { Button } from "../ui/button";
import Image from "next/legacy/image";
import PartyIcon from "@/assets/images/party-icon.svg";

const ModalFullSubscription = ({ isOpen, setIsOpen }) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Portal>
        <Dialog.Overlay asChild>
          <>
            <div className='fixed inset-0 z-[89] w-screen h-screen bg-background/80 backdrop-blur-sm'></div>
            <div className='fixed top-0 z-[89] left-0 w-full h-full lg:flex'>
              <div className='hidden w-full lg:inline'>
                <DotLottiePlayer
                  autoplay
                  loop
                  mode='normal'
                  src='https://lottie.host/d32eae98-9229-4dd2-8832-55c0eb02a2ea/30DNE5oGCm.lottie'
                />
              </div>
              <div className='w-full'>
                <DotLottiePlayer
                  autoplay
                  loop
                  mode='normal'
                  src='https://lottie.host/d32eae98-9229-4dd2-8832-55c0eb02a2ea/30DNE5oGCm.lottie'
                />
              </div>
            </div>
          </>
        </Dialog.Overlay>
        <Dialog.Content
          onInteractOutside={(e) => {
            e.preventDefault();
          }}
          className='fixed bg-white text-background left-[50%] top-[50%] z-[99] grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-3 border bg-background p-4 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg md:w-full'
        >
          <div className='inline-block mx-auto flex-shrink-0 relative h-24 -mt-20 lg:-mt-20 translate-x-6 aspect-[990/917]'>
            <Image
              src={PartyIcon.src}
              alt=''
              layout={"fill"}
              objectFit={"cover"}
            />
          </div>
          <div className='text-center'>
            <p className='text-3xl font-semibold tracking-tight'>
              Congratulations!
            </p>
            <p className='mt-2 text-sm opacity-60'>
              You have successfully activated your full subscription
            </p>
            <p className='mt-1 text-sm opacity-60'>
              Dive in and explore the enhanced experiences we’ve tailored just
              for you. Your journey to the best content starts now!
            </p>
          </div>
          <Dialog.Close>
            <Button
              variant='secondary'
              className='w-full'
              onClick={() => location.reload()}
            >
              Okay, I got it!
            </Button>
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default ModalFullSubscription;
